import { render } from "./EventCreate.vue?vue&type=template&id=a502bc82&scoped=true"
import script from "./EventCreate.vue?vue&type=script&lang=js"
export * from "./EventCreate.vue?vue&type=script&lang=js"

import "./EventCreate.vue?vue&type=style&index=0&id=a502bc82&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a502bc82"

export default script